import PropTypes from 'prop-types';
import React from 'react';
import { SCEmptyState } from 'rollup-allspark';
import notFound from '../assets/images/not-found-exclamation.svg';

const ComponentPlaceholder = ({
  imgSrc = notFound,
  imgHeight = 64,
  imgWidth = 64,
  label = 'Nothing here yet',
  subLabel = '',
  children = null,
  containerClass = '',
}) => (
  <SCEmptyState
    title={label}
    subtitle={subLabel || undefined}
    icon={<img src={imgSrc} alt={label} width={imgWidth} height={imgHeight} />}
    className={containerClass}
  >
    {children}
  </SCEmptyState>
);

ComponentPlaceholder.propTypes = {
  imgSrc: PropTypes.string,
  imgWidth: PropTypes.number,
  imgHeight: PropTypes.number,
  label: PropTypes.string,
  subLabel: PropTypes.string,
  children: PropTypes.element,
  containerClass: PropTypes.string,
};

export default ComponentPlaceholder;
